import React from 'react';

const SvgComponent = props => (
  <svg data-name="Layer 1" viewBox="0 0 25 25" {...props}>
    <defs />
    <path
      d="M1.26 18h16.66a5.93 5.93 0 0 1 4.52 2.09 12.49 12.49 0 0 0 0-15.18A5.94 5.94 0 0 1 17.85 7H1.26A12.42 12.42 0 0 0 .5 9h15.94a3.51 3.51 0 0 1 0 7H.5a12.41 12.41 0 0 0 .76 2z"
      fill="none"
    />
    <path
      className="cls-2"
      d="M4.85 2.62l.43-.32zM1.76 6.1q.19-.31.39-.61c-.15.2-.26.4-.39.61zM2.31 5.26l.32-.43zM5.5 2.14l.6-.38zM3.49 3.84l.37-.37zM4.07 3.27l.54-.47zM1.34 6.87q.13-.27.28-.53-.15.26-.28.53zM2.82 4.6q.18-.28.46-.54-.28.26-.46.54zM22.41 4.89a12.49 12.49 0 0 0-16.19-3.2A13.9 13.9 0 0 1 10.49 7h7.36a5.94 5.94 0 0 0 4.56-2.11zM22.44 20.07A5.93 5.93 0 0 0 17.92 18H10.7a13.87 13.87 0 0 1-4.12 5.53A12.55 12.55 0 0 1 1.27 18a12.5 12.5 0 0 0 21.17 2.07zM11.41 12.49A15 15 0 0 1 11 16h5.44a3.51 3.51 0 0 0 0-7H11a13.83 13.83 0 0 1 .41 3.49z"
    />
    <path
      className="cls-3"
      d="M11.41 12.49A13.83 13.83 0 0 0 11 9H.5a12.49 12.49 0 0 0 0 7H11a15 15 0 0 0 .41-3.51zM2.63 4.83l.19-.23zM2.15 5.49l.16-.23zM1.26 7l.07-.14zM1.62 6.35l.14-.25zM3.86 3.47l.21-.2zM3.28 4.06l.2-.21zM6.22 1.69l-.12.07.12-.07zM5.28 2.3l.22-.16zM4.61 2.81l.24-.19zM6.22 1.69l-.12.07-.6.38-.22.16-.43.32-.24.19-.54.47-.21.2-.37.37-.2.21q-.29.26-.47.54l-.18.23-.32.43-.16.23q-.2.3-.39.61l-.14.25q-.15.26-.28.53L1.27 7h9.23a13.9 13.9 0 0 0-4.28-5.31zM1.26 17.97l.01.01h9.44v-.01H1.26zM6.58 23.51A13.87 13.87 0 0 0 10.7 18H1.27a12.55 12.55 0 0 0 5.31 5.51z"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/ElasticLogo.es6.js